<template>
  <div class="image-placeholder" :style="style" />
</template>

<script>
export default {
  props: {
    width: {
      type: [String, Number],
      default: 50,
    },
    height: {
      type: [String, Number],
      default: 50,
    },
  },
  computed: {
    style() {
      return {
        width: this.width + 'px',
        height: this.height + 'px',
      }
    },
  },
}
</script>

<style lang="scss">
@import '~assets/css/colors.scss';

.image-placeholder {
  border: 1px solid $grey150;
  border-radius: 50%;
  background-color: $silver;
  box-shadow: 0px 1px 4px rgba(0, 0, 0, 0.15);
}
</style>
